import React, { Component, PropTypes } from 'react'
import ReactDOM from 'react-dom'
import _ from 'lodash'
import D3AreaChart from './d3_area_chart'

class AreaChart extends React.Component{
  static propTypes = {
    data: PropTypes.array,
    domain: PropTypes.object,
    type: PropTypes.string
  }

  constructor(props){
    super(props)
  }

  componentDidMount() {
    const el = ReactDOM.findDOMNode(this.refs.svgWrapper)
    const height = $('#introduction .slider').get(0).clientHeight / 3.5
    D3AreaChart.create(el, this.props.data, {height})
  }

  componentDidUpdate() {
    var el = ReactDOM.findDOMNode(this.refs.svgWrapper)
    const height = $('#introduction .slider').get(0).clientHeight / 3.5
    D3AreaChart.update(el, this.props.data, {height})
  }

  componentWillUnmount() {
    var el = (this.refs.svgWrapper)
    D3AreaChart.destroy(el)
  }

  render() {
    return (
      <div className='area-chart-wrapper'>
        <div className="svg-wrapper" ref="svgWrapper"></div>
      </div>
    )
  }
}

module.exports = AreaChart


/** WEBPACK FOOTER **
 ** assets/javascripts/introduction/area_chart.js
 **/